import { render, staticRenderFns } from "./InteractionEditModal.vue?vue&type=template&id=577b1bfc&scoped=true&"
import script from "./InteractionEditModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./InteractionEditModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577b1bfc",
  null
  
)

export default component.exports